import React, { useState } from "react";

const DeleteSelectedPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDeleteSelectedPopup, setShowDeleteSelectedPopup] =
      useState<boolean>(false);

    const deleteSelectedToggleHandler = () => {
      setShowDeleteSelectedPopup(!showDeleteSelectedPopup);
    };

    return (
      <Component
        showDeleteSelectedPopup={showDeleteSelectedPopup}
        deleteSelectedToggleHandler={deleteSelectedToggleHandler}
        {...props}
      />
    );
  };

export default DeleteSelectedPopupHOC;
